<template>
  <div style="display: flex;flex-direction: column;">
    <cargo-repeat-value-select
      v-model="job.cNptNo"
      :disabled="disabled"
      :options="options"
      allow-create
      label-field="no"
      value-field="no"
      unique-field="no"
      :match-of-repeat-value="matchOfCNpt"
      filterable
      clearable
      @change="onChange('cNptNo')"
    />
    <el-input v-model="job.cNptName" :disabled="disabled" type="textarea" :rows="3" style="margin-top: 5px;" @change="onChange('cNptName')" />
  </div>
</template>

<script>
import cargoRepeatValueSelect from '@/components/Cargo/Common/cargoRepeatValueSelect'

export default {
  name: 'SeCnptNo',
  components: {
    cargoRepeatValueSelect
  },
  props: {
    job: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false },
    options: { type: Array, default: () => { return [] } }
  },
  data() {
    return {
      matchOfCNpt: options => {
        const option = options.find(p => p.no === this.job.cNptNo)
        return option || options[0]
      }
    }
  },
  methods: {
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.job[key] }])
    }
  }
}
</script>
